module.exports = {"siteTitle":"The Hidden Life of Wolves","navigation":[{"title":"Wolves 101","slug":"wolves-101","defaultView":{"parent":"","view":""}},{"title":"Explore the Wolf","slug":"explore-the-wolf","defaultView":{"parent":"wolfmap","view":"appWolfmap"}},{"title":"Ecosystem","slug":"ecosystem","defaultView":{"parent":"","view":""}},{"title":"About","slug":"about","defaultView":{"parent":"","view":""}},{"title":"Take Action","slug":"take-action","defaultView":{"parent":"","view":""}}]}


//////////////////
// WEBPACK FOOTER
// ./static/data/site-config.json
// module id = DIQl
// module chunks = 0